// conversation-capabilities.js — 원문 Provider가 실제로 열어 준 동작만 화면에 낸다.
//
// Loom은 대화 본문을 소유하지 않는다. 따라서 UI가 "새 대화"나 "기록 남기기"를
// 보여 주려면, 단순히 Space가 active인지가 아니라 현재 Provider가 append를 실제로
// 제공하는지도 확인해야 한다. 알 수 없을 때 쓰기 버튼을 낙관적으로 열지 않는다.

import { read } from '../api/client.js';
import { useResource } from '../api/resource.js';
import { useSession } from '../session/session.jsx';

export const NATIVE_CONVERSATION_PROVIDER = 'loom-native';

export function useNativeConversationCapabilities(spaceId) {
  const session = useSession();
  const resource = useResource(`space:${spaceId}:conversation-capabilities`, () =>
    read('conversation-capabilities', { nodeId: session.nodeId, query: { spaceId } }),
  );
  const provider = resource.status === 'ready'
    ? (resource.data.providers ?? []).find((item) => item.providerId === NATIVE_CONVERSATION_PROVIDER) ?? null
    : null;

  return {
    resource,
    canRead: provider?.capabilities?.read === true,
    canAppend: provider?.capabilities?.append === true,
  };
}
